// Enclosure Service - API communication for enclosure/adequacy checks
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class EnclosureService {
    
    // Get laboratory adequacy check results
    static async getLaboratoryAdequacyCheck(appId, orgId, assessmentTypeId) {
        try {
            const response = await axios.get(`${API_BASE_URL}/laboratory/adequacy-check`, {
                params: { appId, orgId, assessmentTypeId }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching laboratory adequacy check:', error);
            throw error;
        }
    }

    // Upload file for enclosure section (Updated to work with new S3 system)
    static async uploadFile(formData, fileType) {
        try {
            // For backward compatibility, we'll use the new files API
            const response = await axios.post(`${API_BASE_URL}/files/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error uploading file:', error);
            throw error;
        }
    }

    // Delete uploaded file (Updated to work with new S3 system)
    static async deleteFile(orgId, appId, fileType) {
        try {
            // For the new system, we'll use remove-reference to keep files but deactivate them
            const response = await axios.post(`${API_BASE_URL}/files/remove-reference`, {
                orgId,
                fieldName: fileType === 'QMS' ? 'qmsFile' : 'ptFile'
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting file:', error);
            throw error;
        }
    }

    // Check if section is freezed
    static async checkFreezed(appId, section) {
        try {
            const response = await axios.get(`${API_BASE_URL}/application/check-freezed`, {
                params: { appId, section }
            });
            return response.data;
        } catch (error) {
            console.error('Error checking freeze status:', error);
            throw error;
        }
    }

    // Submit application
    static async submitApplication(orgId, appId, submissionData) {
        try {
            const response = await axios.post(`${API_BASE_URL}/application/submit`, {
                orgId,
                appId,
                ...submissionData
            });
            return response.data;
        } catch (error) {
            console.error('Error submitting application:', error);
            throw error;
        }
    }

    // Send to CAB
    static async sendToCAB(appId, password) {
        try {
            const response = await axios.post(`${API_BASE_URL}/application/send-to-cab`, {
                appId,
                password
            });
            return response.data;
        } catch (error) {
            console.error('Error sending to CAB:', error);
            throw error;
        }
    }

    // Update QMS file
    static async updateQMSFile(appId, orgId, qmsFile) {
        try {
            const response = await axios.put(`${API_BASE_URL}/laboratory/qms-file/${appId}/${orgId}`, {
                qmsFile
            });
            return response.data;
        } catch (error) {
            console.error('Error updating QMS file:', error);
            throw error;
        }
    }

    // Get QMS file information
    static async getQMSFile(appId, orgId) {
        try {
            const response = await axios.get(`${API_BASE_URL}/laboratory/qms-file/${appId}/${orgId}`);
            return response.data.qmsFile;
        } catch (error) {
            console.error('Error fetching QMS file:', error);
            throw error;
        }
    }

    // Remove QMS file
    static async removeQMSFile(appId, orgId) {
        try {
            const response = await axios.delete(`${API_BASE_URL}/laboratory/qms-file/${appId}/${orgId}`);
            return response.data;
        } catch (error) {
            console.error('Error removing QMS file:', error);
            throw error;
        }
    }

    // Get file URL for viewing
    static async getFileUrl(fileName) {
        try {
            const response = await axios.get(`${API_BASE_URL}/files/url/${encodeURIComponent(fileName)}`);
            return response.data;
        } catch (error) {
            console.error('Error getting file URL:', error);
            throw error;
        }
    }
}

export default EnclosureService;